import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-tag",
  templateUrl: "./med-icon-tag.component.html",
})
export class MedIconTagComponent extends SvgMixinComponent {}
